<div *ngIf="authoringContentData" id="managePopUp">
    <div class="modal-header">
        <h4 class="modal-title pl-2" id="modal-basic-title">{{authoringContentData?.managePairing?.managePairingCTA}}({{selectedLine.length}})</h4>
        <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0">
            <mat-accordion *ngFor="let line of selectedLine; let i=index;">
                <form [formGroup]="form">
                    <mat-expansion-panel [expanded]="line.expendFlag" (opened)="expansionPanelOpened(line)" (closed)="expansionPanelClosed(line)">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="accordion-txt">
                                {{line.msisdn}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="row mb-3">
                            <div class="col-6 col-sm-6">
                                <mat-radio-group  [formControl]="line.radioOptionSelected" (change)="onInputEligibilityCheck(line)">
                                    <div class="row">
                                        <div class="col-4">
                                            <mat-radio-button value="PAIR" [disabled]="line.disablePair">
                                                {{authoringContentData?.managePairing?.radioBtnPair}}
                                            </mat-radio-button>
                                        </div>
                                        <div class="col">
                                            <mat-radio-button value="UNPAIR" [disabled]="line.disableUnpair">
                                                {{authoringContentData?.managePairing?.radioBtnUnpair}}
                                            </mat-radio-button>
                                        </div>
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                            <div class="row mb-3">
                                <div class="col-6 col-sm-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{ line.gsmLineLabel }}</mat-label>
                                            <input placeholder="714-555-5555" matInput maxlength="10" type="tel" matInput [formControl]="line.gsmLineFormControl" (ngModelChange)="onInputEligibilityCheck(line)">
                                            <mat-hint *ngIf="line.gsmError" class="text-danger">{{line.errorMessage}}</mat-hint>
                                            <mat-error>
                                                {{authoringContentData?.managePairing?.invalidLineMsg}}
                                            </mat-error>
                                        </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 col-sm-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>{{ line.digitLineLabel }}</mat-label>
                                            <input placeholder="714-555-5555" matInput maxlength="10" type="tel" matInput [formControl]="line.digitsLineFormControl" (ngModelChange)="onInputEligibilityCheck(line)">
                                            <mat-hint *ngIf="line.digitError" class="text-danger">{{line.errorMessage}}</mat-hint>
                                            <mat-error>
                                                {{authoringContentData?.managePairing?.invalidLineMsg}}
                                            </mat-error>
                                        </mat-form-field>
                                </div>
                            </div>
                        <div class="row align-items-center h-100 mt-4">
                            <div class="col-12 col-md-4 mb-2">
                            <button type="button" class="col-12 primary_btn" [disabled]="!line.eligibleSuccess" (click)="nextStep(line)">{{authoringContentData?.manageLine?.next}}
                            </button>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                            <a href="javascript:void(0)" class="small-pink" (click)="removeLine(line)">{{authoringContentData?.manageLine?.removeNumber}} </a>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <hr>
                </form>
            </mat-accordion>

    </div>
    <div class="modal-footer">
        <div class="col-xs-11 col-11 col-sm-11 col-lg-11 col-md-11 mb-4 advisementMsg">
            <div>
                Advisements:
                <br><br>
                {{authoringContentData?.managePairing?.advisementMsg}}
            </div>
        </div>
        <div class="row w-100">
            <div class="col-12 col-sm-12 col-md-6">
                <button type="button" class="btn primary_btn" (click)="onSubmit()" [disabled]="!submitChangeValue">
                    {{authoringContentData?.managePairing?.submitPairingBtn}}
                </button>
            </div>
        </div>
    </div>
</div>